"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../../../../../button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ExcessFormulaHeader = function ExcessFormulaHeader(_ref) {
  var canExceed = _ref.canExceed,
    labels = _ref.labels,
    ruleChange = _ref.ruleChange,
    toggle = _ref.toggle,
    isExpanded = _ref.isExpanded,
    disabled = _ref.disabled,
    COMPONENT_IDENTIFIER = _ref.COMPONENT_IDENTIFIER;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "excess-formula-header"
  }, /*#__PURE__*/_react["default"].createElement("span", null, labels.EXCESS_FORMULA_TITLE), canExceed && /*#__PURE__*/_react["default"].createElement(_button.Button, {
    disabled: disabled,
    className: "expand-button",
    type: "link",
    action: function action() {
      ruleChange(COMPONENT_IDENTIFIER, isExpanded ? null : []);
      toggle(0);
    }
  }, isExpanded ? labels.EXCESS_FORMULA_RETRACT_LABEL : labels.EXCESS_FORMULA_EXPAND_LABEL));
};
ExcessFormulaHeader.defaultProps = {
  errors: {}
};
ExcessFormulaHeader.propTypes = {
  isExpanded: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  canExceed: _propTypes["default"].bool.isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  errors: _propTypes["default"].shape({}),
  COMPONENT_IDENTIFIER: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = ExcessFormulaHeader;